<template>
    <!-- <div id="footer-bar" class="footer-bar footer-bar-detached"> -->
    <div id="footer-bar" class="footer-bar">
        <router-link :to="{ name: 'home' }"><i class="bi bi-book-fill font-17"></i><span>Quran</span></router-link>
        <router-link :to="{ name: 'khazanah.index' }"><i class="bi bi-bookshelf font-15"></i><span>Khazanah</span></router-link>
        <router-link v-if="$store.state.token" :to="{ name: 'bookmark' }"><i class="bi bi-bookmark-fill font-16"></i><span>Bookmark</span></router-link>
        <!-- <router-link :to="{ name: 'login' }"><i class="bi bi-people font-16"></i><span>Login</span></router-link> -->
        <a href="javascript:void(0)" v-if="!$store.state.token" @click="login"><i class="bi bi-people font-16"></i><span>Login</span></a>
        <a href="javascript:void(0)" v-if="$store.state.token" @click="logout"><i class="bi bi-people font-16"></i><span>Logout</span></a>
    </div>
</template>

<script>
import { GoogleAuthProvider, signInWithPopup, getAuth } from 'firebase/auth'
import { mapActions } from 'vuex'
import cookie from 'vue-cookie'

export default {
    name: 'Footer',
    methods: {
        ...mapActions('auth', ['loginByGoogle']),
        login() {
            const provider = new GoogleAuthProvider()
            const auth = getAuth()

            signInWithPopup(auth, provider)
                .then((result) => {
                    this.loginByGoogle({
                        email: result.user.email,
                        uid: result.user.uid
                    })
                        .then(() => {
                            let route = this.$route.name
                            if(route != 'home') {
                                this.$router.push({ name: 'home' })
                            }
                        })
                        .catch(err => console.log(err))
                })
                .catch(error => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log(errorCode, errorMessage)
                })
        },
        logout() {
            cookie.delete('token')
        }
    }
}
</script>